import React from 'react';
import {
  Box,
  Flex,
  InputGroup,
  InputLeftElement,
  Input,
  IconButton,
  HStack,
  Text,
  Avatar,
  useColorMode,
  useColorModeValue,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  Button
} from '@chakra-ui/react';
import { FiSearch, FiSun, FiMoon, FiBell, FiChevronDown } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import NotificationPopover from './NotificationPopover';

const Navbar = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  const { logout, currentUser } = useAuth();
  const navigate = useNavigate();

  const bgColor = useColorModeValue('gray.100', 'gray.900');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const textColor = useColorModeValue('gray.700', 'gray.200');
  const searchBg = useColorModeValue('gray.200', 'gray.700');
  const menuBg = useColorModeValue('white', 'gray.700');
  const menuHoverBg = useColorModeValue('gray.100', 'gray.600');

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  return (
    <Box bg={bgColor} px={6} py={3} borderBottom="1px" borderColor={borderColor}>
      <Flex h={16} alignItems="center" justifyContent="space-between">
        {/* Search Input */}
        <Box flex="1" maxW="md" mr={6}>
          <InputGroup>
            <InputLeftElement
              pointerEvents="none"
              children={<FiSearch color="gray.300" />}
            />
            <Input
              type="text"
              placeholder="Search user, chatbots, agents..."
              borderRadius="md"
              bg={searchBg}
              borderColor={borderColor}
              _placeholder={{ color: 'gray.400' }}
            />
          </InputGroup>
        </Box>

        {/* Right Section */}
        <HStack spacing={4}>
          {/* Theme Toggle Button */}
          <IconButton
            aria-label="Toggle theme"
            icon={colorMode === 'light' ? <FiMoon /> : <FiSun />}
            onClick={toggleColorMode}
            variant="ghost"
            colorScheme="gray"
          />

          {/* Notifications Button */}
          <NotificationPopover />

          {/* User Profile Menu */}
          <Menu>
            <MenuButton
              as={Button}
              variant="ghost"
              size="sm"
              rightIcon={<FiChevronDown />}
              _hover={{
                bg: useColorModeValue('gray.200', 'gray.600'),
                boxShadow: 'md',
              }}
              _active={{
                 bg: useColorModeValue('gray.300', 'gray.700'),
              }}
              borderRadius="full"
              p={2}
            >
              <HStack spacing={3} alignItems="center">
                <Avatar 
                  size="sm" 
                  name={currentUser?.username || 'User'} 
                  src=""
                  border="2px solid"
                  borderColor={useColorModeValue('purple.400', 'purple.600')}
                  bg={useColorModeValue('purple.100', 'purple.800')}
                />
                <Box textAlign="left">
                  <Text 
                    fontWeight="bold" 
                    fontSize="sm" 
                    color={textColor}
                    isTruncated
                    maxW="120px"
                  >
                      {currentUser?.username || 'User'}
                    </Text>
                  <Text fontSize="xs" color="gray.500" isTruncated maxW="120px">{currentUser?.email || ''}</Text>
                </Box>
              </HStack>
            </MenuButton>
            <MenuList bg={menuBg} borderColor={borderColor} boxShadow="lg">
              {currentUser && <MenuDivider />}

              <MenuItem onClick={handleLogout} _hover={{ bg: menuHoverBg }}>
                Logout
              </MenuItem>
            </MenuList>
          </Menu>
        </HStack>
      </Flex>
    </Box>
  );
};

export default Navbar;
